import { useLocation } from 'react-router-dom';
import fi from './fi';
import en from './en';

const translations = { fi, en };

export function useTranslation() {
  const { pathname } = useLocation();
  const isEn = pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'fi';
  const t = translations[lang];
  const basePath = isEn ? '/en/' : '';
  const togglePath = isEn ? '/' : '/en/';
  return { t, lang, basePath, togglePath };
}

export { fi, en };
